<style lang="scss" scoped>
.selector {
	&.threeColumn {
		.selector {
			&__option {
				width: 33.333%;
				&:nth-child(2) {
					border-right: 1px dashed #bfcbd9;
				}
			}
			&__break {
				&:nth-child(1) {
					left: 33.333%;
				}
				&:nth-child(2) {
					left: 66.666%;
				}
			}
		}
	}
	border-radius: 4px;
	width: 100%;
	border: 1px dashed #bfcbd9;
	position: relative;
	&__option {
		display: inline-block;
		width: 50%;
		text-align: center;
		padding: 30px 0 20px 0;
		cursor: pointer;
		&:nth-child(1) {
			border-right: 1px dashed #bfcbd9;
		}
		&:hover {
			background: #f0f1f4;
		}
		/deep/ img {
			max-width: 35px;
			max-height: 35px;
			margin-bottom: 10px;
		}
	}
	/deep/ &__label label {
		font-weight: bold;
		color: $headerColor;
		font-size: 16px;
		display: block;
		cursor: inherit;
	}
	&__break {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 30px;
		background: #a5a7ab;
		text-align: center;
		border-radius: 50%;
		height: 30px;
		line-height: 32px;
		margin-left: -15px;
		margin-top: -15px;
		font-weight: bold;
		color: white;
	}
}
</style>

<template lang="pug">
    .selector(:class="{ threeColumn: numberOfOptions === 3 }")
        div(v-if="showOrElememt")
            .selector__break OR
            .selector__break(v-if="numberOfOptions === 3") OR
        div
            .selector__option(@click="$emit('leftClick')")
                .selector__label
                    slot(name="left")
            .selector__option(v-if="numberOfOptions === 3", @click="$emit('middleClick')")
                .selector__label
                    slot(name="middle")
            .selector__option(@click="$emit('rightClick')")
                .selector__label
                    slot(name="right")
</template>

<script>
export default {
	props: {
		showOrElememt: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		numberOfOptions() {
			if (!this.$slots.left) {
				console.error("`ThisOrThat.vue` component expects a `left` named slot.");
			}

			if (!this.$slots.right) {
				console.error("`ThisOrThat.vue` component expects a `right` named slot.");
			}

			return Object.keys(this.$slots).length;
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/ui/ThisOrThat.vue